import initialState from 'src/state'
import * as types from 'src/actions/types'

export default (state = initialState.windowWidth, action) =>
  action.type === types.SET_WINDOW_WIDTH ? Number(action.payload) : state
